var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4"},[_c('a',{attrs:{"href":"https://github.com/jankowski-app","target":"_blank"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-github")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }